import { createContext } from 'react';

export type PlaybackDock = 'first' | 'current' | 'now' | 'last';

export interface DateRange {
  start: Date;
  end: Date;
}

export interface PlayerContextValue {
  currentTimestamp: Date | null;
  isPlaying: boolean;
  playbackSpeed: number;
  clockStart: Date | null;
  clockMinuteCount: number;
  currentIndex: number;
  autoLoop: boolean;
  selectedDateRange: DateRange | null;
  liveStartMinutes: number;
  liveEndMinutes: number;
  liveEndMinutesForRadar: number;
  isLiveMode: boolean;
  playbackDock: PlaybackDock;
  play: () => void;
  pause: () => void;
  togglePlayPause: () => void;
  setCurrentIndex: (index: number) => void;
  setPlaybackSpeed: (speed: number) => void;
  setAutoLoop: (loop: boolean) => void;
  stepForward: () => void;
  stepBackward: () => void;
  setSelectedDateRange: (range: DateRange | null) => void;
  setLiveStartMinutes: (minutes: number) => void;
  setLiveEndMinutes: (minutes: number) => void;
  setLiveEndMinutesForRadar: (minutes: number) => void;
  setIsLiveMode: (live: boolean) => void;
  setPlaybackDock: (dock: PlaybackDock) => void;
}

export const PlayerCtx = createContext<PlayerContextValue | null>(null);
